
import {CREATE_TOAST, REMOVE_TOAST_BY_ID} from '../constants';


export const createToast = (props = {}) => {
    return {
        type: CREATE_TOAST,
        props
    };
};

export const removeToastById = (id) => {
    return {
        type: REMOVE_TOAST_BY_ID,
        payload: {id}
    };
};

export default {
    createToast, removeToastById
};
